// extracted by mini-css-extract-plugin
export var addressInformationBubbleContainer = "_mh-0";
export var buttonContainer = "_mh-3";
export var cancelButton = "_mh-4";
export var headerSection = "_mh-6";
export var headerTitle = "_mh-9";
export var messageSideLeft = "_mh-1";
export var messageSideRight = "_mh-2";
export var orderNumberContainer = "_mh-7";
export var orderNumberLabel = "_mh-8";
export var submitButton = "_mh-5";